import { render, staticRenderFns } from "./Information_mobile.vue?vue&type=template&id=376a7280&scoped=true&"
import script from "./Information_mobile.vue?vue&type=script&lang=js&"
export * from "./Information_mobile.vue?vue&type=script&lang=js&"
import style0 from "./Information_mobile.vue?vue&type=style&index=0&id=376a7280&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376a7280",
  null
  
)

export default component.exports